<template>
    <div class="flex w-full thunderbite__content">
        <iframe
            :src="iFrameUrl"
            :style="iFrameStyle"
            ref="thunderbiteFrame"
            class="thunderbite__iframe"
            allowtransparency="true"
        />
        <div
            v-if="user"
            class="thunderbite__copy"
        >
            <p class="thunderbite__copy-text">
                <a
                    :href="serverConfig.calendarGame.calendarGameTermsUrl"
                    target="_blank"
                    class="thunderbite__copy-link"
                >
                    {{ $t('calendarGame.regulationsLink') }}
                </a>
                {{ $t('calendarGame.marketingAgreement') }}
            </p>
        </div>
    </div>
</template>

<script>
    import {
        isMobileLayout,
        isMobileDevice,
    } from '@superbet-group/web.lib.vue-utilities';
    import {
        mapGetters,
        mapActions,
    } from 'vuex';

    import { RouteName } from '@app/router/constants/RouteName';
    import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

    export default {
        name: 'AdventCalendar',
        data() {
            return {
                iFrameHeight: 1000,
            };
        },
        created() {
            if (!this.user) {
                this.setLoginModal();
            }

            this.frameMessageListener = window.addEventListener('message', (message) => {
                const frameWindow = this.$refs.thunderbiteFrame && this.$refs.thunderbiteFrame.contentWindow;
                if (message.source !== frameWindow) {
                    return;
                }
                this.iFrameHeight = message.data.frameHeight || 1000;
            });
        },
        computed: {
            ...mapGetters('data/country', {
                serverConfig: 'config',
            }),
            iFrameUrl() {
                return `${this.serverConfig.calendarGame.calendarGameUrl}?a=${this.queryParam}`;
            },
            ...mapGetters('data/authentication', [
                'user',
            ]),
            queryParam() {
                return this.user ? this.user.userId : 'x';
            },
            iFrameStyle() {
                if (isMobileLayout() || isMobileDevice()) {
                    return {};
                }
                return {
                    height: `${this.iFrameHeight}px`,
                };
            },
        },
        watch: {
            user(val) {
                if (!val) {
                    this.landingRedirect();
                }
            },
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            setLoginModal() {
                this.setModal({
                    code: modalCodes.login,
                    afterClose: this.landingRedirect,
                });
            },
            landingRedirect() {
                this.$router.push({ name: RouteName.App.Home });
            },
        },
        beforeDestroy() {
            if (this.frameMessageListener) {
                window.removeEventListener(this.frameMessageListener);
            }
        },
    };
</script>
